export const routesPermission = {
    Admin: ["/home", "/cart", "/order", "/stock", "/details", "/report"],
    "Stock Manager": ["/stock"],
}